<template>
    <div class="vogue-detail">
        <Loading v-if="loadMask"/>
        <div class="content-box">
            <h3>{{title}}</h3>
            <h4>{{subTitle}}</h4>
            <p class="content" v-html="content"></p>
        </div>
        <p class="line"></p>
        <div class="relate-script">
            <h3>本期推荐剧本</h3>
            <ul class="relate-list">
                <li v-for="(item,index) in recList" :key="index">
                    <router-link :to="{name:'scriptdetail',query:{id:item&&item.id,type:item&&item.type}}">
                        <img :src="item.image" alt="">
                        <div class="relate-intro">
                            <p class="title">{{item.title}}</p>
                            <p class="info">{{item.intro}}</p>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading.vue'
export default {
    name:"VogueDetail",
    data(){
        return{
            loadMask:true,
            content:'',              //储存爆款详情正文内容
            title:'',                //主标题
            subTitle:'',             //副标题
            recList:''               //推荐剧本列表
            //item.type  1是电影2是电视剧
        }
    },
    created(){
        Axios.get('/hot/'+this.$route.query.id)
        .then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.title=response.data.data.title
                    this.subTitle=response.data.data.desc
                    this.content=response.data.data.content
                    this.recList=response.data.data.recommend
                    this.loadMask=false
                }
            }
        )
        .catch(
            error=>{
                console.log(error)
            }
        )
    },
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
    .vogue-detail{
        .content-box{
            background:#fff;
            padding:128px 24px 30px 24px;
        }
        h3{
            font-size:30px;
            color:#222;
            margin-bottom:24px;
            font-weight:bold;
        }
        h4{
            font-size:24px;
            color:#222;
            margin-bottom:36px;
        }
        /deep/.content{
            width:100% !important;
            white-space: pre-wrap;
            font-size:24px;
            color:#888;
            line-height:44px;
            white-space:pre-wrap !important;
            a{
                color:#888 !important;
                text-decoration:underline !important;
            }
            pre{
                white-space:pre-wrap !important;
                margin-bottom:20px !important;
            }
            img{
                display:block;
                max-width:100% !important;
                height:auto !important;
                margin:0 auto !important;
                margin-top:20px !important;
                margin-bottom:20px !important;
            }
        }
        .line{
            height:10px;
            background:#f7f7f7;
        }
        .relate-script{
            background:#fff;
            h3{
                font-size:28px;
                color:#333;
                padding:30px 38px;
                position:relative;
                margin-bottom:0;
            }
            h3:before{
                content:"";
                width:4px;
                height:18px;
                background:#bf0000;
                position:absolute;
                left:24px;
                top:50%;
                margin-top:-9px;
            }
            .relate-list{
                padding:0 24px;
                li:first-child{
                    padding-top:0;
                }
                li:last-child{
                    border:none;
                }
                li{
                    border-bottom:1px solid #f7f7f7;
                    padding:40px 0;
                    img{
                        width:120px;
                        height:174px;
                        float:left;
                        margin-right:32px;
                    }
                    .relate-intro{
                        .title{
                            font-size:30px;
                            color:#333;
                            margin-bottom:30px;
                            font-weight:bold;
                        }
                        .info{
                            font-size:24px;
                            color:#222;
                            line-height:38px;
                            overflow:hidden;
                            text-overflow:ellipsis;
                            display:-webkit-box;
                            -webkit-line-clamp:3;
                            -webkit-box-orient:vertical;
                        }
                    }
                }
            }
        }
    }
</style>